var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEarthOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23697_65248)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00005 0.777344C3.56362 0.777344 0.777832 3.56313 0.777832 6.99957C0.777832 10.436 3.56362 13.2218 7.00005 13.2218C10.4365 13.2218 13.2223 10.436 13.2223 6.99957C13.2184 3.56475 10.4349 0.781263 7.00005 0.777344ZM1.67611 7.17477L2.27077 7.37299L3.00055 8.46766V9.03788C3.00058 9.15575 3.04742 9.26877 3.13077 9.3521L4.33388 10.5552V11.6117C2.74177 10.6903 1.73716 9.01324 1.67611 7.17477ZM7.00081 12.3329C6.61631 12.3322 6.23304 12.2897 5.8577 12.2063L6.11192 11.444L6.91414 9.43871C6.96841 9.3028 6.95228 9.14888 6.87103 9.02716L6.24392 8.08627C6.16146 7.96268 6.02271 7.88847 5.87414 7.88849H3.68303L3.12836 7.05605L4.0737 6.11071H4.77859V6.9996H5.66747V5.78449L7.38659 2.7756L6.61503 2.33471L6.23503 2.9996H5.01636L4.53414 2.2756C5.84422 1.58427 7.38471 1.47603 8.77859 1.97738V3.44405C8.77859 3.68951 8.97757 3.88849 9.22303 3.88849H9.87414C10.0227 3.88851 10.1615 3.8143 10.2439 3.69071L10.6337 3.10582C11.1413 3.57928 11.5519 4.14702 11.8426 4.77738H10.0319C9.82014 4.77751 9.63787 4.92704 9.59636 5.13471L9.27503 7.12138C9.24382 7.31335 9.34105 7.50332 9.51503 7.59027L11.0008 8.33294L11.3053 10.1356C10.3046 11.5145 8.70454 12.3314 7.00081 12.3329Z",
    fill: "var(--secondary-6)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23697_65248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthOutlined);
export default __webpack_public_path__ + "static/media/earthOutlined.769db2516a5c33b0522560e9dc0e4c62.svg";
export { ForwardRef as ReactComponent };